import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/tailwind.css'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')


Object.filter = function( obj, predicate) {
  var result = {}, key;
  // ---------------^---- as noted by @CMS, 
  //      always declare variables with the "var" keyword

  for (key in obj) {
      if (obj.hasOwnProperty(key) && !predicate(obj[key])) {
          result[key] = obj[key];
      }
  }

  return result;
};
